import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { getFTTBFirewallService } from 'pages/Internet/store/selectors/firewallSelectors';
import { SuccessStatus } from '../../../../components';

export const FirewallFutureRequestSuccessStatus = compose(
  connect((state) => ({
    id: getFTTBFirewallService(state).futureRequestId,
    shouldRender: !!getFTTBFirewallService(state).futureRequestId,
  })),
  withRenderFlag,
)(SuccessStatus);
